<template>
  <div>
    <v-card v-if="groups[284]" tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <v-list class="py-0">
              <v-list-item class="px-0">
                <v-list-item-avatar color="success" size="50">
                  <v-icon dark>mdi-account</v-icon>
                </v-list-item-avatar>
                <v-list-item-content class="py-0 px-1">
                  <v-row>
                    <v-col cols="12" lg="4">
                      <div class="caption grey--text">Nama KFSP</div>
                      <div class="body-1 black--text font-weight-medium">
                        {{ akun.nama }}
                      </div>
                    </v-col>
                    <v-col cols="12" lg="4">
                      <div class="caption grey--text">Instansi</div>
                      <div class="body-1 black--text font-weight-medium">
                        {{ instansi.nama || '' }}
                      </div>
                    </v-col>
                    <v-col v-if="false" cols="12" lg="4">
                      <div class="caption grey--text">Predikat</div>
                      <div class="body-1 black--text font-weight-medium">
                        <v-chip
                          :class="['white--text']"
                          :color="
                            colorPredikat[$getDeepObj(meta, 'rekap.m_kinerja_predikat_psp.k_kinerja_predikat_psp')]
                          "
                          dark
                        >
                          {{ $getDeepObj(meta, 'rekap.m_kinerja_predikat_psp.keterangan') }}
                        </v-chip>
                      </div>
                      <div v-if="groups[284]" class="mt-1">
                        <div class="body-2 caption">
                          FSP:
                          <span :class="[`${isLengkapNilai(2) ? 'green' : 'red'}--text`]">
                            {{ isLengkapNilai(2) ? 'Sudah' : 'Belum' }} menilai
                          </span>
                        </div>
                        <div class="body-2 caption">
                          Penjab PSP:
                          <span :class="[`${isLengkapNilai(4) ? 'green' : 'red'}--text`]">
                            {{ isLengkapNilai(4) ? 'Sudah' : 'Belum' }} menilai
                          </span>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card v-if="sasarans.length > 1" flat>
      <v-card-text class="py-0">
        <v-tabs v-model="kKinerjaFungsiPsp">
          <v-tab v-for="(sasaran, id) in sasarans" :key="id" :value="sasaran.value" class="text-capitalize">
            {{ sasaran.text }}
          </v-tab>
        </v-tabs>
      </v-card-text>
    </v-card>
    <v-divider v-if="sasarans.length > 1" />
    <list-kinerja
      ref="list"
      :k-kinerja-fungsi-psp="$getDeepObj(sasarans[kKinerjaFungsiPsp], `value`)"
      :is-allow-edit="$allow('psp-peserta-kinerja.save')"
      @meta="onMeta"
    />
  </div>
</template>

<script>
import ListKinerja from '@views/gtk/kinerja/List';
import { mapState } from 'vuex';

export default {
  name: 'PenilaianKinerja',
  components: { ListKinerja },
  data() {
    return {
      meta: {},
      kKinerjaFungsiPsp: 0,
      colorPredikat: {
        1: 'green',
        2: 'blue',
        3: 'orange',
      },
    };
  },
  computed: {
    ...mapState('preferensi', {
      akun: (state) => state.data?.akun ?? {},
      instansi: (state) => state.data?.instansi ?? {},
      groups: (state) => state.data?.groups ?? {},
    }),

    sasarans() {
      let result = [];

      if (this.groups[284]) {
        result.push({ value: 2, text: 'Fasilitator' });
      }

      if (this.groups[326]) {
        result.push({ value: 3, text: 'KFSP' });
      }

      return result;
    },
  },
  mounted() {
    this.$refs.list.fetchData();
  },
  methods: {
    isLengkapNilai(kKinerjaFungsi) {
      const rekap = this.$getDeepObj(this.meta, 'rekap.rekap') || {};
      const rekapFungsi = rekap[kKinerjaFungsi] || {};

      return rekapFungsi.jumlah === rekapFungsi.sasaran;
    },
    onMeta(meta) {
      this.meta = meta;
    },
  },
  watch: {
    kKinerjaFungsiPsp: function() {
      this.$nextTick(() => {
        this.$refs.list.fetchData();
      });
    },
  },
};
</script>

<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
.sc-notif {
  background-color: #c8e6c9;
}
</style>
